import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';

const AreYouSurePopUp = (props) => {
  let title;
  let continueText;
  let breakText;
  if (!props.selectedAction) {
    title = 'האם אתם בטוחים שתרצו להסיר את IMEI הנבחר?';
    continueText = 'בטוחים';
    breakText = 'חזרה לפרטי מנוי';
    if (props.res?.isConnectedToInsurance) {
      title = `הסרת ה IMEI תסיר אוטומטית את שירות אמש"ת אליו הוא מקושר. האם להמשיך?`;
      continueText = 'כן';
      breakText = 'חזרה לפרטי מנוי';
    }
  } else {
    title = 'האם אתם בטוחים שתרצו להוסיף את IMEI שהוקלד?';
    continueText = 'בטוחים';
    breakText = 'חזרה לפרטי מנוי';
  }
  return (
    <Container fluid>
      <Image src={require('./error.svg')} />
      <div className='client-information-change-hetPay-text'>
        <Row className='justify-content-center d-flex flex-column  '>
          <span className='popup-title-bold'>שימו לב!</span>
          <span className='popup-title'>{title}</span>
        </Row>
      </div>
      <Row className='justify-content-center mt-4'>
        <BtnSubmit
          isBusiness
          text={continueText}
          onclick={() => {
            props.setIsShowPopup(false);
            props.ImeiAction(props.selectedImei, props.selectedAction, true);
          }}
        />
      </Row>
      <Row className='justify-content-center mt-1 '>
        <BtnWhite
          isBusiness
          text={breakText}
          onclick={() => {
            props.setIsShowPopup(false);
          }}
        />
      </Row>
    </Container>
  );
};

export default AreYouSurePopUp;
